import {Entity} from '../core/entity/core.base.entity';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {SystemEntity} from './system.entity';
import {Column} from "../core/entity/core.entity.column";

@EntityTable('folder', 'c7d881eb-413f-4093-8674-481acd77790b')
export class FolderEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @JoinColumn(FieldTypeKind.GUID, FolderEntity, true, false, FieldRelationKind.BELONGS_TO, 'parentFolder', 'aliasId', 'parentFolderId')
    public parentFolderId: string;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.LONG)
    public kind: number;

    @Column(FieldTypeKind.ANY)
    public options: any;

    @Transient()
    public parentFolder: FolderEntity;

}
